import { FileText, FileCode, FileCheck } from "lucide-react";
import "../styles/ComplianceAudit.scss";

const ComplianceAudit = () => {
  return (
    <section
      id="compliance-audit"
      className="compliance-audit2"
      aria-labelledby="audit-process-heading"
    >
      <div className="compliance-audit2__bg-gradient" aria-hidden="true"></div>
      <div className="compliance-audit2__bg-image" aria-hidden="true"></div>
      
      <div className="compliance-audit2__container">
        <header className="compliance-audit2__header">
          <h2 id="audit-process-heading" className="compliance-audit2__title">
            Our 3-Step Audit Process
          </h2>
          <p className="compliance-audit2__subtitle">
            We identify and resolve accessibility issues through our
            comprehensive, proven methodology:
          </p>
        </header>

        <div role="region" aria-label="Audit steps" className="compliance-audit2__steps">
          {/* Step 1 */}
          <article className="compliance-audit2__card">
            <header className="compliance-audit2__card-header">
              <div className="compliance-audit2__icon-wrapper" aria-hidden="true">
                <FileText className="compliance-audit2__icon" aria-hidden="true" />
              </div>
              <h3 className="compliance-audit2__card-title">
                AccessiBridge Overview Report
              </h3>
            </header>

            <p className="compliance-audit2__card-text">
              Our initial assessment scans all pages under your domain,
              categorizing accessibility issues by severity and impact. This
              easy-to-read report provides stakeholders with clear priorities
              and a foundation to take action.
            </p>
            <a
              target="_blank"
              href="https://reports.accessibridge.com/sample/audit_overview_contact_form_high_level_only.html"
              className="compliance-audit2__button"
              rel="noopener noreferrer"
            >
              View Sample Overview Report
            </a>
          </article>

          {/* Step 2 */}
          <article className="compliance-audit2__card">
            <header className="compliance-audit2__card-header">
              <div className="compliance-audit2__icon-wrapper" aria-hidden="true">
                <FileCode className="compliance-audit2__icon" aria-hidden="true" />
              </div>
              <h3 className="compliance-audit2__card-title">
                AccessiBridge Remediation Blueprint
              </h3>
            </header>

            <p className="compliance-audit2__card-text">
              Building on the Overview Report, this technical document provides
              developers and content creators with specific code-level and
              content recommendations needed to address identified issues.
            </p>

            <p className="compliance-audit2__card-text">
              Outcome: Detailed action plan with clear technical solutions for
              achieving compliance
            </p>

            <a
              target="_blank"
              href="https://reports.accessibridge.com/sample/audit_detail_contact_form_with_guided_tests.html"
              className="compliance-audit2__button"
              rel="noopener noreferrer"
            >
              View Sample Remediation Blueprint
            </a>
          </article>

          {/* Step 3 */}
          <article className="compliance-audit2__card">
            <header className="compliance-audit2__card-header">
              <div className="compliance-audit2__icon-wrapper" aria-hidden="true">
                <FileCheck className="compliance-audit2__icon" aria-hidden="true" />
              </div>
              <h3 className="compliance-audit2__card-title">
                AccessiBridge Expert Audit
              </h3>
            </header>

            <p className="compliance-audit2__card-text">
              Our accessibility specialists conduct a comprehensive review to
              identify all compliance issues, providing an in-depth assessment
              of your website against the highest accessibility standards.
            </p>

            <p className="compliance-audit2__card-text">
              Outcome: Detailed verification report highlighting all areas that
              need addressing to meet EAA, WCAG, and BFSG requirements.
            </p>

            <a
              target="_blank"
              href="https://reports.accessibridge.com/sample/WCAG_Expert_Audit_Sample_DE.pdf"
              className="compliance-audit2__button"
              rel="noopener noreferrer"
            >
              View Sample Expert Audit
            </a>
          </article>
        </div>

        <div className="compliance-audit2__footer">
          <p className="compliance-audit2__footer-text">
            Our support doesn't end with the audit—we remain available to assist throughout the implementation process, ensuring your website achieves and maintains full compliance.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ComplianceAudit; 